
const ArtCard = ({ id, title, image_url, isSingle }) => {
  return (
    <article className={`thumbnail ${isSingle ? 'single' : ''}`}>
        <img src={image_url} alt={title || `Artwork ${id}`} />
    </article>
  )
}

export default ArtCard